import { render, staticRenderFns } from "./poprc_list.vue?vue&type=template&id=50cb1736&scoped=true&"
import script from "./poprc_list.vue?vue&type=script&lang=js&"
export * from "./poprc_list.vue?vue&type=script&lang=js&"
import style0 from "./poprc_list.vue?vue&type=style&index=0&id=50cb1736&scoped=true&lang=less&"
import style1 from "./poprc_list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb1736",
  null
  
)

export default component.exports